import { render } from "./Main.vue?vue&type=template&id=ebde72f8"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=ebde72f8&lang=scss"
script.render = render

export default script